export default {
  // 登录权限-是否购买学习机
  getPermission: () => `/xkh/teacherapi/base/permission`,
  // 登录-用户信息
  getLogininfo: () => `/xkh/teacherapi/base/logininfo`,
  // 退出登录
  logout: () => `//www.aixuexi.com/surrogates/passport/user/logout`
}
